import { EventMetricsKeys } from '../types';

export default [
  // https://data-portal.internal.atlassian.com/analytics/registry/60967
  {
    key: EventMetricsKeys.PageRedirectedSLOQualityRecommendations,
    data: {
      actionSubject: 'page',
      action: 'redirected',
      actionSubjectId: 'sloQualityRecommendations',
      source: 'homepage',
    },
  },
  {
    key: EventMetricsKeys.PageRedirectedTeam,
    data: {
      actionSubject: 'page',
      action: 'redirected',
      actionSubjectId: 'team',
      source: 'homepage',
    },
  },
  {
    key: EventMetricsKeys.PageRedirectedProduct,
    data: {
      actionSubject: 'page',
      action: 'redirected',
      actionSubjectId: 'product',
      source: 'homepage',
    },
  },
  {
    key: EventMetricsKeys.PageRedirectedLegacyCatalog,
    data: {
      actionSubject: 'page',
      action: 'redirected',
      actionSubjectId: 'legacyCatalog',
      source: 'homepage',
    },
  },
];
